import { useGetRequest } from "@ch/api/useGetRequest";
import { PrescriptionControllerService } from "@ch/generated";
import { useAppSelector } from "@ch/redux-store/hooks/useAppSelector";

const useGetPrescriptionById = (id = "", lazy = true) => {
  const user = useAppSelector((state) => state.user.currentUser);
  const { data, loading, refetch } = useGetRequest({
    service: PrescriptionControllerService.prescriptionControllerFindById,
    tag: "prescriptionControllerFindById",
    payload: {
      id,
      filter: {
        where: {
          userId: user?.id,
        },
      },
    },
    enabled: lazy,
  });

  return {
    prescriptionsPassport: data,
    loading,
    refetch,
  };
};

export default useGetPrescriptionById;
